import AppWindow from "../images/lightIcons/AppWindow.svg";
import GlobeHemisphereWest from "../images/lightIcons/GlobeHemisphereWest.svg";
import Headset from "../images/lightIcons/Headset.svg";

export const CompanyInfo = [
  { icon: GlobeHemisphereWest, title: "Countries", number: 8, suffix: "+" },
  { icon: Headset, title: "Support", number: 24, suffix: "/7" },
  { icon: AppWindow, title: "Projects", number: 50, suffix: "+" },
];
